<template>
  <div class="index">
    <div class="index-con">
      <div class="big-title">
        <span>{{ $t("newsDetailText28") }}</span>
      </div>
      <div class="small-title">（{{ $t("newsDetailText27") }}）</div>
      <div class="lists">
        <div class="list" v-for="(item, index) in list" :key="index">
          <div class="pic">
            <img :src="'https://mk.chinaman.cn/mybigdatas/ids/static/os2/' +
              Number(index + 1) +
              '.png'
              " alt="" />
          </div>
          <div class="name">{{ item.zhtext }}</div>
          <div class="name">{{ item.entext }}</div>
          <a :href="item.a" v-if="index == 1" target="_blank">
            https://www.buhlergroup.cn/global/en
            <br />
            /locations/China-Changzhou.html
          </a>
          <a :href="item.a" v-else target="_blank">{{ item.a }}</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      list: [
        {
          url: "1.jpg",
          zhtext: "尚好科技有限公司",
          entext: "SOHAO FD-Tech Co., Ltd.",
          a: "https://www.sohaofd.com/en/",
        },
        {
          url: "2.jpg",
          zhtext: "布勒（常州）机械有限公司",
          entext: "Buhler (Changzhou) Machinery Co., Ltd.",
          a: "https://www.buhlergroup.cn/global/en/locations/China-Changzhou.html",
        },
        {
          url: "3.png",
          zhtext: "常州一步干燥设备有限公司",
          entext: "Changzhou Yibu Drying Equipment Co., Ltd.",
          a: "https://www.yibudryer.com/",
        },
        {
          url: "4.gif",
          zhtext: "江苏楷益智能科技股份有限公司",
          entext: "Jiangsu Kaiyi Intelligent Technology Co., Ltd.",
          a: "https://www.kaaechina.com/",
        },
        {
          url: "5.png",
          zhtext: "海通食品集团有限公司",
          entext: "Haitong Food Group Co., Ltd.",
          a: "https://www.haitong-food.com/",
        },
        {
          url: "6.jpg",
          zhtext: "浙江吉宠商贸有限公司",
          entext: "Zhejiang Jichong Trading Co., Ltd.",
          a: "https://xianlangcwsp.tmall.com/",
        },
        {
          url: "7.jpg",
          zhtext: "郑州雪麦龙食品香料有限公司",
          entext: "Zhengzhou Xuemailon Food Flavor Co., Ltd.",
          a: "https://www.xuemailon.cn/",
        },
        {
          url: "8.jpg",
          zhtext: "四川江茂食品有限公司",
          entext: "Sichuan Jiangmao FOODS Co., Ltd.",
          a: "http://www.jiangmaofd.com/en/",
        },
        {
          url: "9.jpg",
          zhtext: "无锡市林洲干燥设备有限公司",
          entext: "Wuxi Linzhou Drying Equipment Co., Ltd.",
          a: "http://www.linzhou.com/en/",
        },
        {
          url: "10.png",
          zhtext: "江苏禾润世家绿色食品有限公司",
          entext: "Jiangsu Herun Shijia Green Food Co., Ltd.",
          a: "",
        },
        {
          url: "11.png",
          zhtext: "广东嘉豪食品有限公司",
          entext: "Guangdong Galore Food Co., Ltd.",
          a: "",
        },
        {
          url: "12.jpg",
          zhtext: "上海金丝猴食品股份有限公司",
          entext: "Shanghai Golden Monkey Food Co., Ltd.",
          a: "http://www.jinsihou.com.cn/",
        },
        {
          url: "13.jpg",
          zhtext: "郑州鼎力集团郑州鼎力新能源技术有限公司",
          entext: "Zhengzhou Dingli New Energy Technology Co., Ltd.",
          a: "http://www.dldry.com/en_index.asp",
        },

        {
          url: "14.png",
          zhtext: "江苏博莱客冷冻科技发展有限公司",
          entext:
            "Jiangsu BoLaiKe Refrigeration Science and Technology Development Co., Ltd.",
          a: "https://www.jsblk.com/en",
        },
        {
          url: "15.jpg",
          zhtext: "山东天力能源股份有限公司",
          entext: "Shandong Tianli Energy Co., Ltd.",
          a: "https://www.tianlienergy.com/",
        },
        {
          url: "16.png",
          zhtext: "苏州纽迈分析仪器股份有限公司",
          entext: "Suzhou Niumag Analytical Instrument Co., Ltd.",
          a: "https://www.nmranalyzer.com/",
        },
        {
          url: "17.png",
          zhtext: "印度GEM机械及相关产业集团",
          entext: "GEM MACHINERY & ALLIED INDUSTRIES",
          a: "https://gemalliedgroup.com/",
        },
      ],
    };
  },
};
</script>

<style scoped lang="less">
.big-title {
  margin-bottom: 20px;
}

.lists {
  display: flex;
  flex-wrap: wrap;

  .list {
    width: 33.3%;
    text-align: center;
    padding: 0 10px;
    box-sizing: border-box;
    margin-bottom: 30px;
  }

  .pic {
    min-height: 100px;
    display: flex;
    padding: 10px 0;
    align-items: center;
    justify-content: center;
    width: 100%;
    text-align: center;
    height: 100px;
    position: relative;
    overflow: hidden;
  }

  img {
    position: absolute;
    width: auto;
    height: 250px;
    margin-bottom: 10px;
  }
}

.email {
  cursor: pointer;
  color: rgb(30, 98, 222);
  font-weight: 600;
}

.name {
  padding: 0 0px;
  box-sizing: border-box;
}

.index-con {
  margin: 0 auto;
  width: 1200px;
  padding-bottom: 170px;
}

.text {
  box-sizing: border-box;
  color: #333;
  text-indent: 2em;
  font-size: 16px;
  line-height: 2;
  padding-bottom: 20px;
}

.w-350 {
  width: 350px;
  margin: 0 auto;
  text-indent: 0;
  text-align: center;
}

.small-title {
  font-size: 18px;
  font-weight: 600;
  text-align: center;
  margin-bottom: 20px;
}

@media screen and (max-width: 768px) {
  .index-con {
    width: 100%;
  }

  .nav {
    width: 100%;
  }

  .title {
    font-size: 18px;
  }

  .index {
    padding: 40px 10px 0;
    box-sizing: border-box;
  }

  .lists {
    .list {
      width: 100%;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/sponsors.vue